import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getAllProducts } from "../../Redux/Actions";
import { Config } from "../../Config";

const InitialProducts = (props) => {
  const dispatch = useDispatch();
  useEffect(async () => {
    await getAllProduct();
  }, []);

  const getAllProduct = () => {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let data = JSON.stringify({
      ProductCategoryId: null,
      Key: "",
      MinWeight: 0,
      MaxWeight: 0,
      MinCutting: 0,
      MaxCutting: 0,
      MinNumberOfJewels: 0,
      MaxNumberOfJewels: 0,
      MinUnitPrice: 0,
      MaxUnitPrice: 0,
      CountryIds: null,
      OrderBy: 1,
      PageId: 1,
      PageCount: 1,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: data,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/Product/GetCategoryProducts", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        dispatch(getAllProducts(result.data));
      })
      .catch((error) => console.log("error", error));
  };
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default InitialProducts;
